import { ResponseWrapper, PagedResults, UserBasicDto, trackerGet, trackerPost, trackerDelete, trackerPatch, decodeResult } from "./basicApi.ts";
import { ParameterDto } from "./parameter.ts";
import { ScanTypeDto } from "./scanType.ts";
import { Uid } from "../utils.tsx";

interface BeamlineDto {
  id: number;
  slug: string;
  name: string;
  description?: string;
  external_link?: string;
  ids_owners: number[];
  ids_watchers: number[];
  // The noun to use to refer to sets of samples, e.g. "bar".
  set_noun: string;
}


interface BeamlineDetailsDto {
  id: number;
  slug: string;
  name: string;
  description?: string;
  external_link?: string;
  owners: UserBasicDto[];
  watchers: UserBasicDto[];
  // The noun to use to refer to sets of samples, e.g. "bar".
  set_noun: string;
  parameters: ParameterDto[];
  scan_types: ScanTypeDto[];
}


interface BeamlineUpdateDto {
  slug: string;
  name?: string;
  description?: string;
  external_link?: string;
  ids_owners?: number[];
  ids_watchers?: number[];
  set_noun?: string;
}


interface SetParameterOrderingDto {
  slug: string;
  order_ids: Uid[];
}


// Get a list of Beamlines the logged-in user has access to
async function getBeamlines(): Promise<ResponseWrapper<PagedResults<BeamlineDto>>> {
  const result = await trackerGet(`beamlines/`, {});
  return decodeResult(result);
}


async function getBeamlineDetailsBySlug(slug: string): Promise<ResponseWrapper<BeamlineDetailsDto>> {
  const result = await trackerGet(`beamlines/${slug}/details/`, {});
  return decodeResult(result);
}


// Update a Beamline record on the server.
async function updateBeamline(dto: BeamlineUpdateDto): Promise<ResponseWrapper<BeamlineDto>> {
  const result = await trackerPatch(`beamlines/${dto.slug}/`, JSON.stringify(dto));
  return decodeResult(result);
}


async function setBeamlineParameterOrder(dto: SetParameterOrderingDto): Promise<ResponseWrapper<ParameterDto>> {
  const result = await trackerPost(`beamlines/${dto.slug}/set_parameter_order/`, JSON.stringify(dto));
  return decodeResult(result);
}


export type { BeamlineDto, BeamlineDetailsDto, BeamlineUpdateDto, SetParameterOrderingDto };
export {  getBeamlines, getBeamlineDetailsBySlug, updateBeamline, setBeamlineParameterOrder }
